import { render, staticRenderFns } from "./PropertyList.vue?vue&type=template&id=0804a0d6&"
import script from "./PropertyList.vue?vue&type=script&lang=ts&"
export * from "./PropertyList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports